import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

class About extends Component {
    constructor(props){
        super(props);
        this.state = {
            about: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Recognized Excellence',
                    text: 'A Must-Have Resource for Professionals: Dive into Adaptive Control with Neural Networks!'
                },
                {
                    id: 2,
                    icon: 'bi bi-support',
                    title: 'Read Anytime, Anywhere',
                    text: 'Access Your Adaptive Control Guide on Any Device!'
                },
                {
                    id: 3,
                    icon: 'bi bi-rocket2',
                    title: 'Your Learning Journey Starts Here!',
                    text: 'Reach Your Goals with Adaptive Control!'
                }
            ]
        }
    }

    gtag_report_conversion = (event, url = null) => {
        if (typeof window.gtag !== "function") {
            console.error("Google Ads is not loaded properly.");
            return;
        }

        window.gtag('event', 'conversion', {
            'send_to': 'AW-16832649503/oq0QCPbF0ZYaEJ-yt9o-'
        });

        console.log("Conversion event sent:", event.target);

        if (url) {
            setTimeout(() => {
                window.location.href = url;
            }, 500);
        }
    };

    
    render() {
        return (
        <section className="about-section section-padding bg-grey" id="about">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <div className="about-img">
                            <img src="assets/images/banner/book.png" alt="" className="img-fluid"/>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="section-heading">
                            <span className="subheading">5% discount on early purchase</span>
                            <h3 className="heading-title">Get 5% Off on Your Early Purchase – Master Adaptive Control with Neural Networks Today!</h3>
                            <p>Early Purchase for the Ultimate Guide to Adaptive Control!</p>
                        </div>

                        {
                            this.state.about.map((data,i) => (
                                <div className="about-text-block" key={i}>
                                    <i className={data.icon}></i>
                                    <h4>{data.title}</h4>
                                    <p>{data.text} </p>
                                </div>
                            ))
                        }
                        
                        <HashLink to="#contact" className="btn btn-main-2" onClick={(event) => this.gtag_report_conversion(event)}><i className="fa fa-check me-2"></i>Preorder Now!</HashLink> 
                    </div>
                </div>
            </div>
        </section>  
        );
    }
}

export default About;
